import script from "./CheckoutRadioButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckoutRadioButton.vue?vue&type=script&lang=ts&setup=true"

import "./CheckoutRadioButton.vue?vue&type=style&index=0&id=e5c33666&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5c33666"]])

export default __exports__